export interface BadgeProps {
  label: string;
  variant?: 'default' | 'success' | 'warning' | 'danger';
  className?: string;
}

const variantClasses: Record<NonNullable<BadgeProps['variant']>, string> = {
  default: 'bg-slate-100 text-slate-800 border border-slate-200',
  success: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
  warning: 'bg-amber-100 text-amber-800 border border-amber-200',
  danger: 'bg-rose-100 text-rose-800 border border-rose-200',
};

export function Badge({ label, variant = 'default', className }: BadgeProps): JSX.Element {
  const badgeClasses = [
    'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
    variantClasses[variant],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={badgeClasses}>{label}</span>;
}
